export const getRemovableObjects = (canvas: fabric.Canvas) => {
  if (!canvas) {
    throw new Error('Canvas is undefined');
  }

  return canvas.getObjects().filter((obj) => {
    return obj.data?.removableOnSave;
  });
};
